import { setLocalTenantId } from "@/lib/storeManager";

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * One-time migration: /{tenantId}/property-portal/... → /...
 * and /{tenantId}/... → /... while persisting tenant in localStorage.
 * Call before React mounts so the first paint uses the clean path.
 */
export function migrateLegacyTenantUrl(): void {
  const pathname = window.location.pathname;
  const parts = pathname.split("/").filter(Boolean);
  if (parts.length === 0) {
    return;
  }

  if (!UUID_RE.test(parts[0])) {
    return;
  }

  const tenantId = parts[0];
  setLocalTenantId(tenantId);

  let rest = parts.slice(1);
  if (rest[0] === "property-portal") {
    rest = rest.slice(1);
  }

  const newPath = rest.length ? `/${rest.join("/")}` : "/login";
  const newUrl = `${newPath}${window.location.search}${window.location.hash}`;
  window.history.replaceState(null, "", newUrl);
}
